import React from 'react';
import { Badge, Button } from '@storebrand-digital/pretzel';
import styles from './DropdownFilter.module.css';

interface ButtonProps {
  isOpen: boolean;
  title: string;
  selectedValues: (string | number)[];
  setReference: React.Ref<HTMLButtonElement>;
  referenceProps: Record<string, unknown>;
  trackId?: string;
}

const DropdownFilterButton: React.FC<ButtonProps> = ({
  isOpen,
  title,
  selectedValues,
  setReference,
  referenceProps,
  trackId,
}) => {
  const hasSelectedValues = selectedValues.length > 0;

  return (
    <Button
      className={styles.dropdownButton}
      size="medium"
      variant="subtle"
      iconRight={isOpen ? 'caret-up' : 'caret-down'}
      data-trackid={trackId || `dropdownFilter-${title}`}
      aria-expanded={isOpen}
      aria-haspopup="listbox"
      ref={setReference}
      {...referenceProps}
    >
      <div className={styles.dropdownButtonLabel}>
        {hasSelectedValues && (
          <Badge
            variant="neutral"
            density="compact"
            heading={String(selectedValues.length)}
          />
        )}
        <span>{title}</span>
      </div>
    </Button>
  );
};

export default DropdownFilterButton;
